export const AddFluxKeyFormData = [
    {
        label: "Flux Key",
        name: "fluxKey",
        rules: [
            {
                required: true,
                message: 'Please Input Flux Key!',
            },
        ]
    }
];